import axios from 'axios';

class RestApiHelper {
  //
  constructor() {
  }

  // --------------- REQUESTS ----------------------------------------------------------------
  static requestPosts(baseUrl, perPage, page, filteredCatTab) {
    let filtersStr = "";
    if(filteredCatTab != null && filteredCatTab.length > 0) {
      filtersStr += "&categories_exclude=" + filteredCatTab.join(",");
    }
    let url = baseUrl + this.postsEndpoint + '?'
                    + "per_page=" + perPage
                    + "&page=" + page
                    + filtersStr;

    return axios.get(url);
  }

  static requestPostsCat(baseUrl, perPage, page, filteredCatTab) {
    let filtersStr = "";
    if(filteredCatTab != null && filteredCatTab.length > 0) {
      filtersStr += "&categories=" + filteredCatTab.join(",");
    }
    let url = baseUrl + this.postsEndpoint + '?'
                    + "per_page=" + perPage
                    + "&page=" + page
                    + filtersStr;

    return axios.get(url);
  }

  static requestCustomPostSlug(baseUrl, endpoint, postSlug) {
    let url = baseUrl
              + endpoint + '?'
              + "slug=" + postSlug
              +"&per_page=1"; // active la lecture de next et prev pour wp/v2
    return axios.get(url);
  }

  static requestCustomPostId(baseUrl, endpoint, postId) {
    let url = baseUrl + endpoint + '?'
              + "id=" + postId;
    return axios.get(url);
  }

  static requestCustomPosts(baseUrl, endpoint, perPage, page) {
    let url = baseUrl + endpoint + '?'
                    + "per_page=" + perPage
                    + "&page=" + page;

    return axios.get(url);
  }

  static requestCustomPostData(baseUrl, endpoint, ids = null, per_page=100, exclude=false) {
    let url = baseUrl + endpoint
              + "?per_page="+per_page+"&page=1";
    if(ids && ids.length > 0) {
      if(exclude==false) {
        url += "&include=" + ids.join(",")
            +"&orderby=include";
      } else {
        url += "&exclude=" + ids.join(",");
      }

    }
    return axios.get(url);
  }

  static requestAllCustomPosts(baseUrl, endpoint) {
    let url = baseUrl + endpoint;
    return axios.get(url);
  }

  static requestPageData(baseUrl, pageId) {
      console.log("request page: ", baseUrl + this.pagesEndpoint + '/' + pageId)
      return axios.get(baseUrl + this.pagesEndpoint + '/' + pageId );
  }

  static requestTaxo(baseUrl, endpoint) {
    return axios.get(baseUrl + endpoint);
  }

  // --------------- DATE-TIME ----------------------------------------------------------------
  // ISO String
  static getNowDateTime() {
    let now = new Date();
    return now.toISOString();
  }
  /** date format = YYYY-mm-ddThh:mm:ss => hh:mm:ss -dd*/
  static getDate(strDateTime) {
    if(strDateTime && strDateTime.length > 0) {
      return strDateTime.split('T')[0];
    } else {
      return strDateTime;
    }
  }

  /** date format = YY-mm-ddThh:mm:ss */
  static getTime(strDateTime) {
    if(strDateTime && strDateTime.length > 0) {
      return strDateTime.split('T')[1];
    } else {
      return strDateTime;
    }
  }

  static getDateTab(strDateTime, defautTab=['01','01','01']) {
    let date_tab = this.getDate(strDateTime).split("-");
    if( date_tab.length == 3 ) {
      return date_tab;
    }
    else {
      return defautTab;
    }
  }
  static getTimeTab(strDateTime, defautTab=['00','00','00']) {
    let time_tab = getTime(strDateTime).split(":");
    if( time_tab.length == 3 || time_tab.length == 2 ) {
      return time_tab;
    }
    else {
      return defautTab;
    }
  }

  /** date format = YYYY-mm-ddThh:mm:ss */
  static getDateReal(strDateTime) {
    return new Date(strDateTime);
  }

  /**
   * @brief Format de date de strDateTime = YYYY-mm-ddThh:mm:ss
   * @return un nombre entre 01"lundi" et 07"dimanche".
   */
  static getDayReal(strDateTime, defaultStr = "") {
    let date = this.getDateReal(strDateTime);
    if(date) {
      let day_idx = date.getDay(); // attention pour date.getDay => "dimanche=0, lundi=1, etc..."
      day_idx = (day_idx - 1 + 7) % 7; // +8 à cause du commentaire du haut
      return day_idx+1;
    } else {
      return defaultStr;
    }
  }

  // ----
  /** strMonthIdx [01:janv] => [12:dec] */
  static getShortMonth(strMonthIdx) {
    let idx = parseInt(strMonthIdx);

    if(idx>=1  && idx<=12) {
      return this.monthsShort()[idx-1];
    } else {
      return strMonthIdx;
    }
  }

  /** strMonthIdx [01=janv] => [12=dec]*/
  static getMonth(strMonthIdx) {
    let idx = parseInt(strMonthIdx);

    if(idx>=1  && idx<=12) {
      return this.months()[idx-1];
    } else {
      return strMonthIdx;
    }
  }

  /** strMonthIdx [01=lun] => [12=dim] */
  static getShortDayStr(strDayIdx) {
    let idx = parseInt(strDayIdx);

    if(idx>=1  && idx<=7) {
      return this.dayShort()[idx-1];
    } else {
      return strDayIdx;
    }
  }

  /** strMonthIdx [01=lun] => [7=dim]*/
  static getDay(strDayIdx) {
    let idx = parseInt(strDayIdx);

    if(idx>=1 && idx<=7) {
      return this.days()[idx-1];
    } else {
      return strDayIdx;
    }
  }

  /** strYear => YYYY */
  static getShortYear(strYear) {
    if(strYear.length == 4) {
      return strYear.slice(2);
    }
    return strYear;
  }

  // ---
  static days() {
    return ['lundi','mardi','mercredi','jeudi','vendredi','samedi','dimanche'];
  }

  static daysShort() {
    return ['lun','mar','mer','jeu','ven','sam','dim'];
  }

  static months() {
    return ['janvier','février','mars','avril','mai','juin','juillet','août', 'septembre', 'octobre', 'novembre', 'décembre'];
  }

  static monthsShort() {
    return ['janv','fév','mars','avril','mai','juin','juillet','août', 'sept', 'oct', 'nov', 'déc'];
  }

  // ---------- misc
  static unescapeStr(str) {
    return _.unescape(str);
  }

  // ---- helper function
  static posToGoogleMaps(lat, lon, zoom = 16.00) {
    if(lat && lon) {
      let real_zoom = zoom ? zoom : 16.0;
      return 'https://www.google.fr/maps/dir//'+lat+","+lon+"/@"+lat+","+lon+','+real_zoom+'z/data=!4m2!4m1!3e0';
    }
    return undefined;
  }

  static getPageLink(baseUrl, pageNumberStr) {
    return baseUrl+RestApiHelper.pagesEndpoint+'/'+pageNumberStr;
  }
};

RestApiHelper.postsEndpoint = "posts";
RestApiHelper.pagesEndpoint = "pages";

export default RestApiHelper;



// WEBPACK FOOTER //
// ./src/helpers/rest-api-func.js